import React from 'react'
import './Box.component.css'

interface IBox {
  id: string
  dataTestId?: string
  height?: string
  width?: string
  fill?: string
  onClick?: () => void
  className?: string
}

const BoxComponent: React.FC<IBox> = ({
  id = '',
  dataTestId = '',
  height = '100px',
  width = '100px',
  fill = 'primary',
  onClick,
  className = '',
  children,
}) => {
  const colorMap: { [key: string]: string } = {
    primary: 'var(--light-primary)',
    'dark-indigo': 'var(--light-dark-indigo)',
    'steel-blue-gray': 'var(--light-steel-blue-gray)',
    'light-blue': 'var(--light-blue)',
    medium: 'var(--ion-color-medium)',
    none: 'transparent',
    // Add more colors if needed
  }

  const backgroundColor = colorMap[fill] || colorMap['primary']

  return (
    <div
      id={id}
      data-testid={dataTestId}
      onClick={onClick}
      className={`${className} custom-box`}
      style={{ height, width, backgroundColor }}>
      <div className='box-content'>{children}</div>
    </div>
  )
}

export default BoxComponent
